common.View.create('website::layouts.main.Footer', {

    onDOMLoad()
    {
        this.linkColors();
    },

    linkColors()
    {
        const footerBackground = this.element.find('.mainBgColor').get(0);
        const bgColor = this.getComputedBackgroundColor(footerBackground);

        if (bgColor && this.isBackgroundDark(bgColor)) {
            footerBackground.classList.add('text-white');
        } else {
            footerBackground.classList.add('text-black');
        }
    },

    getComputedBackgroundColor(element) {
        let color = getComputedStyle(element).backgroundColor;
        if (color === 'rgba(0, 0, 0, 0)' || color === 'transparent') {
            return element.parentElement ? this.getComputedBackgroundColor(element.parentElement) : null;
        } else {
            return color;
        }
    },

    findAncestorWithStyle(el) {
        while (el && el !== document.body) {
            if (el.style && /background|color/.test(el.style.cssText)) {
                return el;
            }
            el = el.parentElement;
        }
        return null;
    },

    isBackgroundDark(color) {
        const rgb = color.match(/\d+/g); 
        const brightness = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return brightness < 125;  // raised threshold
    }
});
